import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App.tsx'
import { BetSlipProvider } from './lib/betslip.tsx'
import { SessionProvider } from './lib/session.tsx'
import './styles/app.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <BetSlipProvider>
          <App />
        </BetSlipProvider>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
)
